import drivingLicenseNL from 'assets/icons/nl-driving-license.svg';
import { TimeMessage } from 'components/newAccountSteps/profileSteps/profileStep3/videocall/messages/timeMessage';
import { isVideoCallAvailable } from 'components/newAccountSteps/profileSteps/profileStep3/videocall/videocallHelper';
import { VIDEO_CALL } from 'constants/identityMethod';
import { COUNTRY_CODE_NL, COUNTRY_DOCUMENT_TYPE_DNI_LABEL } from 'constants/multiLanguage';
import { FormattedText, formatText } from 'core/i18n';
import React, { useEffect } from 'react';
import { useIdentityView } from 'routes/formsView/IdentityVerificationViews/IdentityView/contexts/IdentityViewContext/IdentityViewContext';
import { isMobile } from 'utilities/browser';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { CONTENT_BY_TYPE, IMAGE_BY_COUNTRY } from './constants';
import { IMAGES_PATH } from 'constants/assets';

const DocumentationRequiredHeader = ({ name, documentType, videoSelected, options, withTabs }) => {
    const { isCarrouselActive } = useIdentityView();
    const isVideoCallSelected = videoSelected === VIDEO_CALL;
    const showTimeMessage = isVideoCallSelected && !isVideoCallAvailable({ videoSelected, options });
    const titleByVideoType = isVideoCallSelected
        ? formatText('identity-videoCallSubtitleDesktop')
        : formatText('identity-videoSelfieSubtitleDesktop');

    const shouldHideTitle = withTabs || (isMobile() && showTimeMessage) || !isCarrouselActive;

    useEffect(() => {
        showTimeMessage &&
            recordEventCustomOnly({
                categoriaEvento: 'onboarding',
                accionEvento: 'identidad/videoconferencia/',
                etiquetaEvento: 'servicio no disponible en este momento',
            });
    }, []);

    if (documentType === COUNTRY_DOCUMENT_TYPE_DNI_LABEL && getReferenceCodeByCountry() === COUNTRY_CODE_NL) {
        return (
            <div className="row mb-20">
                <div className="col-sm-12 mobile-bottom-20">
                    <img
                        alt="icon"
                        className={'document-image mr-10'}
                        src={`${IMAGES_PATH}/${IMAGE_BY_COUNTRY[COUNTRY_CODE_NL]}`}
                    />
                    <img alt="icon" className={'document-image document-image--small'} src={drivingLicenseNL} />
                </div>
                <div className="col-sm-12 mt-20">
                    <p className="bolded-text-18 mobile-bottom-20">{name}</p>
                    <p className="bolded-text-16">
                        <FormattedText value="identity-dniNeededText" />
                    </p>
                </div>
            </div>
        );
    }

    const content = CONTENT_BY_TYPE[documentType] || CONTENT_BY_TYPE[COUNTRY_DOCUMENT_TYPE_DNI_LABEL];

    return (
        <div className="documentation-required">
            <div className="video-requirements">
                {!shouldHideTitle && <h6 className="document-required-title">{titleByVideoType}</h6>}
                {showTimeMessage && <TimeMessage />}
                <div className="video-requirements__user">
                    <div>
                        <img alt="icon" className="document-image" src={`${IMAGES_PATH}/${content.image}`} />
                    </div>
                    <div>
                        <p className="bolded-text-18 mobile-bottom-20">{name}</p>
                        <p className="bolded-text-16">
                            <FormattedText value={content.text} />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentationRequiredHeader;
